// Clase de utilidad para validar y corregir consultas SQL - ADAPTADA PARA BASE DE DATOS IQVIA
export default class SQLValidator {
    constructor() {
        // Conflictos de tipos actualizados para el esquema IQVIA
        this.typeConflicts = [
            { pattern: /JOIN\s+\w+\s+\w+\s+ON\s+(\w+\.\w+)\s*=\s*(\w+\.\w+)/gi, types: ['numeric', 'char'] },
            { fields: ['product_cod', 'pack_cod', 'lab_cod', 'corporation_code'], potentialConflict: true },
            { pattern: /WHERE\s+(\w+\.\w+|\w+)\s*[<>=!]+\s*'([^']+)'/gi, types: ['numeric', 'char'] }
        ];

        // Tablas del esquema IQVIA
        this.tables = {
            'public.gps_full': [
                'ADDRESS', 'app1', 'app1_desc', 'app2', 'app2_desc', 'app3', 'app3_desc',
                'atc1', 'atc1_desc', 'atc2', 'atc2_desc', 'atc3', 'atc3_desc', 'atc4', 'atc4_desc',
                'BIRTHDATE', 'BIRTHDATE_DAY', 'BIRTHDATE_MONTH', 'BIRTHDATE_YEAR',
                'doctor_BRICK', 'doctor_brick_desc', 'CEDULA_SEP', 'corp_desc', 'corporation_code',
                'doctor_id', 'dsg_fact', 'dx', 'fcc', 'FIRST_NAME', 'GENDER', 'gene_cod',
                'HONORARIOS', 'ID_ONEKEY', 'ID_PBS', 'lab_cod', 'labdesc', 'LAST_NAME',
                'market', 'molecula', 'nec1', 'nec2', 'nec3', 'nec4',
                'otc1_desc', 'otc2_desc', 'otc3_desc', 'otc4_desc',
                'pack_cod', 'pack_desc', 'pack_lch', 'period', 'prod_lch',
                'product_cod', 'product_desc', 'RANGO_PAT',
                'doctor_region_code', 'doctor_region_description', 'rx', 'segment_flag',
                'SPECIALTY_ID_1', 'SPECIALTY_ID_2', 'doctor_state_code', 'doctor_state_desc',
                'std_fact', 'stgh_mea', 'stgh_val', 'TIPO_CONSULTORIO', 'VISITS_NUMBER',
                'dispensed_brick_code', 'dispensed_brick_desc', 'dispensed_region_code',
                'dispensed_region_description', 'dispensed_state_code', 'dispensed_state_desc'
            ],
            'public.ddd_full': [
                'app1', 'app1_desc', 'app2', 'app2_desc', 'app3', 'app3_desc',
                'atc1', 'atc1_desc', 'atc2', 'atc2_desc', 'atc3', 'atc3_desc', 'atc4', 'atc4_desc',
                'brick_code', 'brick_desc', 'corp_desc', 'corporation_code',
                'dsg_fact', 'fcc', 'gene_cod', 'lab_cod', 'labdesc',
                'market', 'molecula', 'nec1', 'nec2', 'nec3', 'nec4',
                'otc1_desc', 'otc2_desc', 'otc3_desc', 'otc4_desc',
                'pack_cod', 'pack_desc', 'pack_lch', 'period', 'prod_lch',
                'product_cod', 'product_desc', 'region_code', 'region_description',
                'segment_flag', 'state_code', 'state_desc',
                'std_fact', 'stgh_mea', 'stgh_val', 'units', 'values'
            ],
            // Permitir también sin el prefijo 'public.'
            'gps_full': [
                'ADDRESS', 'app1', 'app1_desc', 'app2', 'app2_desc', 'app3', 'app3_desc',
                'atc1', 'atc1_desc', 'atc2', 'atc2_desc', 'atc3', 'atc3_desc', 'atc4', 'atc4_desc',
                'BIRTHDATE', 'BIRTHDATE_DAY', 'BIRTHDATE_MONTH', 'BIRTHDATE_YEAR',
                'doctor_BRICK', 'doctor_brick_desc', 'CEDULA_SEP', 'corp_desc', 'corporation_code',
                'doctor_id', 'dsg_fact', 'dx', 'fcc', 'FIRST_NAME', 'GENDER', 'gene_cod',
                'HONORARIOS', 'ID_ONEKEY', 'ID_PBS', 'lab_cod', 'labdesc', 'LAST_NAME',
                'market', 'molecula', 'nec1', 'nec2', 'nec3', 'nec4',
                'otc1_desc', 'otc2_desc', 'otc3_desc', 'otc4_desc',
                'pack_cod', 'pack_desc', 'pack_lch', 'period', 'prod_lch',
                'product_cod', 'product_desc', 'RANGO_PAT',
                'doctor_region_code', 'doctor_region_description', 'rx', 'segment_flag',
                'SPECIALTY_ID_1', 'SPECIALTY_ID_2', 'doctor_state_code', 'doctor_state_desc',
                'std_fact', 'stgh_mea', 'stgh_val', 'TIPO_CONSULTORIO', 'VISITS_NUMBER',
                'dispensed_brick_code', 'dispensed_brick_desc', 'dispensed_region_code',
                'dispensed_region_description', 'dispensed_state_code', 'dispensed_state_desc'
            ],
            'ddd_full': [
                'app1', 'app1_desc', 'app2', 'app2_desc', 'app3', 'app3_desc',
                'atc1', 'atc1_desc', 'atc2', 'atc2_desc', 'atc3', 'atc3_desc', 'atc4', 'atc4_desc',
                'brick_code', 'brick_desc', 'corp_desc', 'corporation_code',
                'dsg_fact', 'fcc', 'gene_cod', 'lab_cod', 'labdesc',
                'market', 'molecula', 'nec1', 'nec2', 'nec3', 'nec4',
                'otc1_desc', 'otc2_desc', 'otc3_desc', 'otc4_desc',
                'pack_cod', 'pack_desc', 'pack_lch', 'period', 'prod_lch',
                'product_cod', 'product_desc', 'region_code', 'region_description',
                'segment_flag', 'state_code', 'state_desc',
                'std_fact', 'stgh_mea', 'stgh_val', 'units', 'values'
            ]
        };

        // Alias de tablas del esquema IQVIA
        this.aliasMap = {
            'gps': 'gps_full',
            'g': 'gps_full',
            'ddd': 'ddd_full',
            'd': 'ddd_full',
            'pgps': 'public.gps_full',
            'pddd': 'public.ddd_full'
        };

        // Tipos de compatibilidad para el esquema IQVIA
        this.typeCompatibility = {
            // gps_full (Prescripciones por Médico)
            'gps_full.doctor_id': 'numeric',
            'gps_full.period': 'numeric',
            'gps_full.rx': 'numeric',
            'gps_full.dx': 'numeric',
            'gps_full.VISITS_NUMBER': 'numeric',
            'gps_full.product_cod': 'numeric',
            'gps_full.pack_cod': 'numeric',
            'gps_full.fcc': 'numeric',
            'gps_full.lab_cod': 'numeric',
            'gps_full.corporation_code': 'numeric',
            'gps_full.doctor_BRICK': 'numeric',
            'gps_full.doctor_region_code': 'numeric',
            'gps_full.doctor_state_code': 'numeric',
            'gps_full.dispensed_brick_code': 'numeric',
            'gps_full.dispensed_region_code': 'numeric',
            'gps_full.dispensed_state_code': 'numeric',
            'gps_full.BIRTHDATE_DAY': 'numeric',
            'gps_full.BIRTHDATE_MONTH': 'numeric',
            'gps_full.BIRTHDATE_YEAR': 'numeric',
            'gps_full.ID_PBS': 'numeric',
            'gps_full.dsg_fact': 'numeric',
            'gps_full.std_fact': 'numeric',
            'gps_full.stgh_val': 'numeric',
            
            // Campos CHAR en gps_full
            'gps_full.labdesc': 'char',
            'gps_full.corp_desc': 'char',
            'gps_full.atc4_desc': 'char',
            'gps_full.product_desc': 'char',
            'gps_full.pack_desc': 'char',
            'gps_full.molecula': 'char',
            'gps_full.gene_cod': 'char',
            'gps_full.market': 'char',
            'gps_full.segment_flag': 'char',
            'gps_full.FIRST_NAME': 'char',
            'gps_full.LAST_NAME': 'char',
            'gps_full.GENDER': 'char',
            'gps_full.SPECIALTY_ID_1': 'char',
            'gps_full.doctor_state_desc': 'char',
            'gps_full.doctor_region_description': 'char',
            'gps_full.doctor_brick_desc': 'char',
            
            // ddd_full (Ventas por Geografía)
            'ddd_full.period': 'numeric',
            'ddd_full.units': 'numeric',
            'ddd_full.values': 'numeric',
            'ddd_full.product_cod': 'numeric',
            'ddd_full.pack_cod': 'numeric',
            'ddd_full.fcc': 'numeric',
            'ddd_full.lab_cod': 'numeric',
            'ddd_full.corporation_code': 'numeric',
            'ddd_full.brick_code': 'numeric',
            'ddd_full.region_code': 'numeric',
            'ddd_full.state_code': 'numeric',
            'ddd_full.dsg_fact': 'numeric',
            'ddd_full.std_fact': 'numeric',
            'ddd_full.stgh_val': 'numeric',
            
            // Campos CHAR en ddd_full
            'ddd_full.labdesc': 'char',
            'ddd_full.corp_desc': 'char',
            'ddd_full.atc4_desc': 'char',
            'ddd_full.product_desc': 'char',
            'ddd_full.pack_desc': 'char',
            'ddd_full.molecula': 'char',
            'ddd_full.gene_cod': 'char',
            'ddd_full.market': 'char',
            'ddd_full.segment_flag': 'char',
            'ddd_full.state_desc': 'char',
            'ddd_full.region_description': 'char',
            'ddd_full.brick_desc': 'char',
            
            // Con prefijo public. (duplicar los mismos)
            'public.gps_full.doctor_id': 'numeric',
            'public.gps_full.period': 'numeric',
            'public.gps_full.rx': 'numeric',
            'public.gps_full.dx': 'numeric',
            'public.gps_full.labdesc': 'char',
            'public.ddd_full.period': 'numeric',
            'public.ddd_full.units': 'numeric',
            'public.ddd_full.values': 'numeric',
            'public.ddd_full.labdesc': 'char'
        };
    }

    // MÉTODO cleanMarkdown MEJORADO
    cleanMarkdown(sql) {
        if (!sql || typeof sql !== 'string') return sql;

        let cleanedSQL = sql;

        // 1. Limpiar formato Markdown básico
        cleanedSQL = cleanedSQL.replace(/^```sql\s*/gm, '');
        cleanedSQL = cleanedSQL.replace(/^```\s*/gm, '');
        cleanedSQL = cleanedSQL.replace(/\s*```$/gm, '');

        // 2. Limpiar comentarios con # (estilo Python/Shell)
        cleanedSQL = cleanedSQL.replace(/^#.*$/gm, '');
        cleanedSQL = cleanedSQL.replace(/\s*#[^\r\n]*/g, '');

        // 3. Limpiar títulos y texto descriptivo común
        cleanedSQL = cleanedSQL.replace(/^Consulta SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Query.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Here.*SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Aquí.*SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^La consulta.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Esta consulta.*$/gmi, '');

        // 4. Extracción de SQL más inteligente
        const sqlStartPattern = /(?:^|\n)\s*((?:SELECT|WITH|INSERT|UPDATE|DELETE)\b)/im;
        const sqlStartMatch = cleanedSQL.match(sqlStartPattern);

        if (sqlStartMatch) {
            const startIndex = cleanedSQL.indexOf(sqlStartMatch[1]);
            let sqlPart = cleanedSQL.substring(startIndex);

            // Buscar donde termina el SQL válido
            const endPatterns = [
                /\n\s*(?:Esta consulta|This query|Explanation|Explicación|Note|Nota)/i,
                /\n\s*(?:El resultado|The result|Como se puede|As you can)/i,
                /\n\s*(?:\*\*|##|\d+\.)/m
            ];

            let endIndex = sqlPart.length;
            for (const pattern of endPatterns) {
                const match = sqlPart.match(pattern);
                if (match && match.index < endIndex) {
                    endIndex = match.index;
                }
            }

            cleanedSQL = sqlPart.substring(0, endIndex);
        }

        // 5. Limpiar líneas vacías múltiples
        cleanedSQL = cleanedSQL.trim();
        cleanedSQL = cleanedSQL.replace(/^\s*\n+/g, '');
        cleanedSQL = cleanedSQL.replace(/\n\s*\n\s*\n/g, '\n\n');

        // 6. Asegurar que termine con punto y coma
        if (cleanedSQL && !cleanedSQL.trim().endsWith(';')) {
            cleanedSQL = cleanedSQL.trim() + ';';
        }

        // 7. Validación final
        const hasWithOrSelect = /\b(WITH|SELECT)\b/i.test(cleanedSQL);
        if (!hasWithOrSelect) {
            console.error("🚨 SQL no válido: no tiene SELECT o WITH");
            return sql;
        }

        return cleanedSQL;
    }

    // Verificar estructuras incompletas en SQL (adaptado para IQVIA)
    checkIncompleteStructures(sql) {
        const errors = [];

        // Verificar CASE/END balanceados
        const caseCount = (sql.match(/\bCASE\b/gi) || []).length;
        const endCount = (sql.match(/\bEND\b/gi) || []).length;

        if (caseCount > endCount) {
            errors.push(`Hay ${caseCount - endCount} declaraciones CASE sin cerrar con END`);
        }

        // Verificar operaciones aritméticas con period (NUMERIC)
        if (sql.includes('period') && sql.includes('INTERVAL')) {
            errors.push("Campo 'period' es NUMERIC (YYYYMM), no usar INTERVAL. Usar aritmética de enteros.");
        }

        // Verificar declaraciones CASE incompletas
        const incompleteCase = sql.match(/CASE\s*;/gi);
        if (incompleteCase) {
            errors.push('Declaración CASE incompleta encontrada');
        }

        // Verificar cláusulas WITH sin SELECT
        if (sql.includes('WITH') && !sql.includes('SELECT')) {
            errors.push('Cláusula WITH sin SELECT correspondiente');
        }

        return errors;
    }

    // Validar sintaxis básica de SQL
    validate(sql) {
        if (!sql || typeof sql !== 'string') {
            return { valid: false, errors: ['Consulta SQL vacía o inválida'] };
        }

        sql = sql.trim();
        const errors = [];

        if (!sql.toLowerCase().includes('select')) {
            errors.push('La consulta debe incluir una cláusula SELECT');
        }

        if (!sql.toLowerCase().includes('from')) {
            errors.push('La consulta debe incluir una cláusula FROM');
        }

        // Verificar paréntesis balanceados
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Verificar comillas balanceadas
        const quotes = (sql.match(/'/g) || []).length;
        if (quotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        return {
            valid: errors.length === 0,
            errors: errors
        };
    }

    // Método principal para corregir consultas SQL (ADAPTADO PARA SCHEMA IQVIA)
    fixQuery(sql, errorMessage = '') {
        let fixedSQL = sql.trim();
        let wasFixed = false;
        let fixes = [];

        // Limpiar formato Markdown
        const originalSQL = fixedSQL;
        fixedSQL = this.cleanMarkdown(fixedSQL);
        if (originalSQL !== fixedSQL) {
            wasFixed = true;
            fixes.push('Eliminado formato Markdown');
        }

        // Mapeo de columnas comunes para el esquema IQVIA
        const columnReplacements = {
            // Mapeos comunes generales
            'fecha': 'period',
            'date': 'period',
            'periodo': 'period',
            
            // Mapeos para gps_full (Médicos)
            'medico_id': 'doctor_id',
            'id_medico': 'doctor_id',
            'doctor': 'doctor_id',
            'nombre_medico': 'FIRST_NAME',
            'apellido_medico': 'LAST_NAME',
            'especialidad': 'SPECIALTY_ID_1',
            'specialty': 'SPECIALTY_ID_1',
            'prescripciones': 'rx',
            'prescriptions': 'rx',
            'dispensaciones': 'dx',
            'dispensations': 'dx',
            'visitas': 'VISITS_NUMBER',
            'visits': 'VISITS_NUMBER',
            'estado_medico': 'doctor_state_desc',
            'doctor_state': 'doctor_state_desc',
            'region_medico': 'doctor_region_description',
            'brick_medico': 'doctor_brick_desc',
            
            // Mapeos para ddd_full (Ventas)
            'unidades': 'units',
            'units_sold': 'units',
            'valores': 'values',
            'ventas': 'values',
            'sales': 'values',
            'valor_ventas': 'values',
            'estado_venta': 'state_desc',
            'region_venta': 'region_description',
            'brick_venta': 'brick_desc',
            
            // Mapeos comunes a ambas tablas
            'laboratorio': 'labdesc',
            'lab': 'labdesc',
            'laboratory': 'labdesc',
            'manufacturer': 'labdesc',
            'fabricante': 'labdesc',
            'corporativo': 'corp_desc',
            'corporation': 'corp_desc',
            'atc': 'atc4',
            'atc_codigo': 'atc4',
            'atc_descripcion': 'atc4_desc',
            'atc_desc': 'atc4_desc',
            'clase_terapeutica': 'atc4_desc',
            'therapeutic_class': 'atc4_desc',
            'producto': 'product_desc',
            'product': 'product_desc',
            'producto_codigo': 'product_cod',
            'product_code': 'product_cod',
            'paquete': 'pack_desc',
            'pack': 'pack_desc',
            'package': 'pack_desc',
            'molecula_nombre': 'molecula',
            'molecule': 'molecula',
            'generico': 'gene_cod',
            'generic': 'gene_cod',
            'mercado': 'market',
            'segmento': 'segment_flag',
            'segment': 'segment_flag'
        };

        for (const [oldColumn, newColumn] of Object.entries(columnReplacements)) {
            if (fixedSQL.includes(oldColumn)) {
                if (newColumn) {
                    const beforeColumnFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(new RegExp(`\\b${oldColumn}\\b`, 'g'), newColumn);
                    if (beforeColumnFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Actualizado nombre de columna: ${oldColumn} → ${newColumn}`);
                    }
                } else {
                    fixes.push(`ADVERTENCIA: Columna ${oldColumn} no existe en el esquema IQVIA`);
                }
            }
        }

        // Corregir función ROUND con AVG
        if (fixedSQL.includes('ROUND(') && fixedSQL.includes('AVG(')) {
            const beforeRoundFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/ROUND\s*\(\s*AVG\s*\(\s*([^)]+)\s*\)\s*,\s*([0-9]+)\s*\)/g, 'ROUND(AVG($1)::numeric, $2)');

            if (beforeRoundFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast ::numeric a función ROUND con AVG');
            }
        }

        // Corregir problemas con period y INTERVAL (period es NUMERIC, no DATE)
        if (sql.includes('period') && sql.includes('INTERVAL')) {
            fixes.push('ADVERTENCIA: period es NUMERIC (YYYYMM). No usar INTERVAL. Usar: period >= 202401 AND period <= 202412');
            
            // Intentar corregir automáticamente
            const beforePeriodFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/period\s*[<>=!]+\s*[^-]*-\s*INTERVAL\s+'[^']+'/gi, 
                "period >= 202301 AND period <= 202412");
            
            if (beforePeriodFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregido filtro de period: eliminado INTERVAL, usando comparación numérica');
            }
        }

        // Corregir DATE_PART o EXTRACT sobre period
        if ((sql.includes('DATE_PART') || sql.includes('EXTRACT')) && sql.includes('period')) {
            const beforeDatePartFix = fixedSQL;
            
            // Convertir DATE_PART('year', period) a FLOOR(period / 100)
            fixedSQL = fixedSQL.replace(/DATE_PART\s*\(\s*['"]year['"]\s*,\s*period\s*\)/gi, 'FLOOR(period / 100)');
            fixedSQL = fixedSQL.replace(/EXTRACT\s*\(\s*year\s+FROM\s+period\s*\)/gi, 'FLOOR(period / 100)');
            
            // Convertir DATE_PART('month', period) a MOD(period, 100)
            fixedSQL = fixedSQL.replace(/DATE_PART\s*\(\s*['"]month['"]\s*,\s*period\s*\)/gi, 'MOD(period, 100)');
            fixedSQL = fixedSQL.replace(/EXTRACT\s*\(\s*month\s+FROM\s+period\s*\)/gi, 'MOD(period, 100)');
            
            if (beforeDatePartFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregido: period es NUMERIC. Usar FLOOR(period/100) para año, MOD(period, 100) para mes');
            }
        }

        // Errores de incompatibilidad numeric = char
        if (errorMessage.includes("operator does not exist") &&
            (errorMessage.includes("numeric = character") || errorMessage.includes("character = numeric"))) {

            const beforeTypeFix = fixedSQL;
            const fieldsMatch = errorMessage.match(/ON\s+(\w+\.\w+)\s*=\s*(\w+\.\w+)/i);

            if (fieldsMatch && fieldsMatch.length >= 3) {
                const leftField = fieldsMatch[1];
                const rightField = fieldsMatch[2];

                // Determinar cuál es NUMERIC y cuál es CHAR
                let numericField, charField;
                if (errorMessage.includes("numeric = character")) {
                    numericField = leftField;
                    charField = rightField;
                } else {
                    numericField = rightField;
                    charField = leftField;
                }

                fixedSQL = fixedSQL.replace(
                    new RegExp(`(${leftField})\\s*=\\s*(${rightField})`, 'g'),
                    `${numericField} = CAST(${charField} AS NUMERIC)`
                );

                if (beforeTypeFix !== fixedSQL) {
                    wasFixed = true;
                    fixes.push(`Añadido CAST para convertir ${charField} a NUMERIC en JOIN`);
                }
            }
        }

        // Corregir divisiones por cero
        if (fixedSQL.includes('/') && !fixedSQL.includes('NULLIF')) {
            const beforeDivisionFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/(\w+)\s*\/\s*(\w+)/g, (match, numerator, denominator) => {
                if (!denominator.includes('NULLIF')) {
                    return `${numerator} / NULLIF(${denominator}, 0)`;
                }
                return match;
            });

            if (beforeDivisionFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido NULLIF para prevenir división por cero');
            }
        }

        return {
            sql: fixedSQL,
            wasFixed,
            fixes
        };
    }

    stringSimilarity(s1, s2) {
        if (!s1 || !s2) return 0;
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();
        if (s1 === s2) return 1.0;

        let matches = 0;
        for (let i = 0; i < Math.min(s1.length, s2.length); i++) {
            if (s1[i] === s2[i]) matches++;
        }
        return matches / Math.max(s1.length, s2.length);
    }

    processQuery(sql, errorMessage = '') {
        sql = this.cleanMarkdown(sql);

        // Verificar errores estructurales
        const structuralErrors = this.checkIncompleteStructures(sql);
        if (structuralErrors.length > 0) {
            console.warn("Errores estructurales detectados:", structuralErrors);
        }

        // Verificar elementos desbalanceados
        const unbalancedElements = this.checkUnbalancedElements(sql);
        if (unbalancedElements.length > 0) {
            console.warn("Elementos no balanceados:", unbalancedElements);
        }

        // Validación normal
        const validationResult = this.validate(sql);

        // Si hay errores, corregir
        if (!validationResult.valid || errorMessage ||
            structuralErrors.length > 0 || unbalancedElements.length > 0) {
            return this.fixQuery(sql, errorMessage);
        }

        return {
            sql: sql,
            wasFixed: false,
            fixes: []
        };
    }

    checkUnbalancedElements(sql) {
        const errors = [];

        // Verificar paréntesis balanceados
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Verificar comillas simples balanceadas
        const singleQuotes = (sql.match(/'/g) || []).length;
        if (singleQuotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        // Verificar comillas dobles balanceadas
        const doubleQuotes = (sql.match(/"/g) || []).length;
        if (doubleQuotes % 2 !== 0) {
            errors.push('Comillas dobles desbalanceadas');
        }

        return errors;
    }
}